module.exports = __webpack_public_path__ + "img/kid-family.b6c1bc47.jpg";